import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteSelectionListValue } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function to delete a Selection List Value.
 */
export const useDeleteSelectionListValue = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call deleteSelectionListValue.
     * @param {Pella.ProductionRequestAPI.SelectionList['id']} id Selection List ID
     */
    mutationFn: (id) => deleteSelectionListValue(id),
    onSuccess: () => {
      toast.success('Selection List Value deleted successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.SELECTION_LISTS] });
    },
  });
};
